export { default } from './SingleAnswerQuizStep';
